// Бэкенд отдаёт `parameter.optionsJson` как JSON-строку (или null) — приводим её к объекту.
export function parseOptionsJson(optionsJson) {
    if (!optionsJson) return null;
    if (typeof optionsJson === "object") return optionsJson;
    try {
        return JSON.parse(optionsJson);
    } catch {
        return null;
    }
}

// ENUM options приходят как { values: ["Common", ...] } (плоские строки), поддерживаем и { allowed: [{code}] }.
export function getEnumAllowedCodes(options) {
    if (Array.isArray(options?.values)) {
        return options.values.map((item) => (typeof item === "string" ? item : item?.code ?? item?.systemName));
    }
    if (Array.isArray(options?.allowed)) {
        return options.allowed.map((item) => (typeof item === "string" ? item : item?.code ?? item?.systemName));
    }
    return [];
}
